import useSWR from "swr";

import { getMegaUsage } from "@/api/record";

import useUserInfo from "./useUserInfo";

const useMegaSearchLimit = () => {
  const { userInfoContext } = useUserInfo();
  const { data, mutate } = useSWR(userInfoContext.userInfo ? "mega-search-limit" : null, () =>
    getMegaUsage()
  );

  if (data?.status === 200) {
    return {
      data: {
        api_count: data.data?.api_count,
        api_limit: data.data?.api_limit,
        disabled: data.data?.api_count >= data.data?.api_limit,
      },
      mutate,
    };
  }

  return {
    data: null,
    mutate,
  };
};

export default useMegaSearchLimit;
